import { Component, OnInit } from '@angular/core';
import { from } from 'rxjs';
import { ContactService } from '../../../services/contact.service';
import { GlobalFlagsService } from '../../../services/global-flags.service';

import { CookieService } from 'ngx-cookie';

import { MatDialog } from '@angular/material/dialog';
import { DialogComponent } from '../../commons/dialog/dialog.component';

import { Router } from '@angular/router';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.scss']
})
export class ContactUsComponent implements OnInit {

  constructor(private contactService: ContactService,
    private globalFlagsService: GlobalFlagsService,
    private cookieService: CookieService,
    private dialog: MatDialog,
    private router: Router) { }

  contactUsForm = {
    name: '',
    email: '',
    message: '',
    gRecaptchaResponse: ''
  };

  isSubmitted = false;
  isSendingForm = false;
  captchaValid = false;
  captchaResponse = null;
  private captchaSiteKey = null;

  ngOnInit() {
    this.captchaSiteKey = this.cookieService.get('recaptcha_key');
    if (!this.captchaSiteKey) {
      this.globalFlagsService.displayLoad(true);
      const captchaKey = from(this.contactService.getCaptchaKey());
      captchaKey
        .subscribe((res) => {
          this.globalFlagsService.displayLoad(false);
          this.captchaSiteKey = res.captchaSiteKey;
          const expire = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
          this.cookieService.put('recaptcha_key', this.captchaSiteKey, {
            expires: expire
          });
        }, (err) => {
          this.globalFlagsService.displayLoad(false);
          const data = { message: 'An error occurred. Please try again later.' };
          this.dialog.open(DialogComponent, { data });
          this.router.navigate(['/']);
          throw err;
        });

    }
  }

  submitForm() {
    this.isSendingForm = true;
    this.contactUsForm.gRecaptchaResponse = this.captchaResponse;
    const contact = from(this.contactService.sendContact(this.contactUsForm));
    contact
      .subscribe((res) => {
        this.isSendingForm = false;
        this.isSubmitted = true;
      }, (err) => {
        this.isSendingForm = false;
        this.isSubmitted = false;
        const errMsg = err.message ? err.message : 'Server has encountered a problem. <br>Sorry for inconvenience, we are working on it';
        const data = { message: `${errMsg}. Please try again.` };
        this.dialog.open(DialogComponent, { data });
        throw err;
      });
  }

  handleCorrectCaptcha(e) {
    this.captchaResponse = e;
    this.captchaValid = true;
  }

  handleExpiredCaptcha() {
    this.captchaResponse = null;
    this.captchaValid = false;
  }

  resetForm() {
    this.isSubmitted = false;
  }

}
